/**
 * 智能客服拨号号码配置相关请求
 * 后端 Controller: CccCallerNumberController
 * 基础路径: /api/v2/ccc/caller
 */
import request from '@/utils/request';

// 主叫号码实体
export interface CccCallerNumber {
  id: number;    // 智能体系统id
  aiAgentId: number; // 智能体id
  name: string;  // 智能体名称
  callers: string; // 主叫号码
  status: number; // 状态: 0-禁用, 1-启用
  tries: number; // 重试次数
  strategyKey: string; // 号码说明/备注
}

export interface CccCallerNumberListParams {
  id?: number;
  aiAgentId?: string;
  name?: string;
  status?: number;
}

// 智能体下拉选项
export interface CccAgentOption {
  id: number;       // 智能体系统id
  aiAgentId: number; // 智能体id
  name: string;     // 智能体名称
}

// 获取智能体下拉选项
export const cccAgentOptionsRequestPath = '/api/v2/ccc/agent/options';
export const cccAgentOptionsRequest = () => {
  return request.get(cccAgentOptionsRequestPath);
};

// 获取主叫号码列表
export const cccCallerNumberListRequestPath = '/api/v2/ccc/agent/list';
export const cccCallerNumberListRequest = (
  params: CccCallerNumberListParams
) => {
  return request.get(cccCallerNumberListRequestPath, {
    params
  });
};

// 获取主叫号码详情
export const cccCallerNumberDetailRequestPath = '/api/v2/ccc/agent';
export const cccCallerNumberDetailRequest = (id: number) => {
  return request.get(`${cccCallerNumberDetailRequestPath}/${id}`);
};

export interface UpsertCccCallerNumberParams {
  id?: number;    // 智能体系统id
  aiAgentId: number; // 智能体id
  name: string;  // 智能体名称
  callers: string; // 主叫号码
  status: number; // 状态: 0-禁用, 1-启用
  tries: number; // 重试次数
  strategyKey: string; // 号码说明/备注
}

// 新增/编辑主叫号码
export const upsertCccCallerNumberRequestPath = '/api/v2/ccc/agent/upsert';
export const upsertCccCallerNumberRequest = (
  data: UpsertCccCallerNumberParams
) => {
  return request.post(upsertCccCallerNumberRequestPath, data);
};

// 删除主叫号码
export const deleteCccCallerNumberRequestPath = '/api/v2/ccc/agent';
export const deleteCccCallerNumberRequest = (id: number) => {
  return request.delete(`${deleteCccCallerNumberRequestPath}/${id}`);
};

// 切换主叫号码启禁用状态
export const toggleCccCallerNumberRequestPath = '/api/v2/ccc/agent';
export const toggleCccCallerNumberRequest = (id: number) => {
  return request.put(`${toggleCccCallerNumberRequestPath}/${id}/toggle`);
};
